import IsIos from '@/mixins/is-ios.js'
import logo from '@/assets/images/collectomate-logo.png'

export default {
  name: 'Offline',
  mixins: [IsIos],
  data: function () {
    return {
      logo: logo,
    }
  },
}
